import { useState } from 'react';
import { Card } from '@mui/material';

import { Page } from '@occc-app/design-system';

import { TobaccoWeeklySubmissionsTableContainer } from './components';

import { routeCreator } from '../retailer-connect.utils';
import { withRetailerNetwork, WithRetailerNetworkProps } from '../hocs/with-retailer-network.hoc';
import { useBreadcrumbLinks } from '../hooks/use-breadcrumb-links.hook';

const PAGE_TITLE = 'All Scan Data Submissions';

const RetailerNetworkTobaccoScanDataPage = ({ retailerNetwork }: WithRetailerNetworkProps) => {
  const [breadcrumbLinks] = useState(() => [
    { label: 'Tobacco', to: routeCreator.tobacco(retailerNetwork.uuid) },
    { label: PAGE_TITLE },
  ]);

  useBreadcrumbLinks(breadcrumbLinks);

  return (
    <Page
      browserTabTitle={PAGE_TITLE}
      pageHeaderProps={{
        title: PAGE_TITLE,
        titleTestId: 'rc-tobacco-scan-data-title',
      }}
      containerProps={{ variant: 'md' }}
    >
      <Card>
        <TobaccoWeeklySubmissionsTableContainer retailerNetworkUuid={retailerNetwork.uuid} />
      </Card>
    </Page>
  );
};

export default withRetailerNetwork(RetailerNetworkTobaccoScanDataPage);
